import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import ProjectDetailsComponent from 'src/modules/project/partials/ProjectDetails.component';
import Project from 'src/entities/Project';
import CapTable from 'src/value-objects/CapTable';
import {
  getProjectCapTable,
  GetProjectCapTableAction
} from 'src/actions/project/cap-table/GetProjectCapTable.actions';

interface StateProps {
  capTable?: CapTable;
}

interface DispatchProps {
  getProjectCapTable: (projectId: number) => Promise<GetProjectCapTableAction>;
}

interface Props extends StateProps, DispatchProps {
  project: Project;
  invest: boolean;
  closedProject: boolean;
}

class ProjectDetailsContainer extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
    this.props.getProjectCapTable(this.props.project!.id);
  }

  public render(): React.ReactNode {
    return (
      this.props.capTable ?
        (
          <ProjectDetailsComponent
            project={this.props.project}
            capTable={this.props.capTable}
            invest={this.props.invest}
            closedProject={this.props.closedProject}
          />
        ) :
        null
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    getProjectCapTable: (projectId: number): Promise<GetProjectCapTableAction> => {
      return dispatch(getProjectCapTable(projectId));
    }
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState):
  StateProps => ({
  capTable: state.getProjectCapTable.projectCapTable
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetailsContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectDetails.container.tsx